module.exports = __webpack_public_path__ + "static/img/3bg_13.e2e51ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_13.png
// module id = 689
// module chunks = 1